import React from "react";
import img1 from "../../assets/img/SF23.jpg";

export const Main = () => {
  return (
    <div className="big">
      <div>
        <img src={img1} alt="" />
      </div>
      <div>
        <p>
     Silverfort is a unified identity protection platform that extends Multi-Factor Authentication (MFA) 
            and Zero Trust access to any resource, including legacy systems, command-line tools, and
             service accounts. It helps organizations prevent identity-based attacks by enforcing adaptive 
             access policies across both cloud and on-premises environments without requiring agents or proxies.
        </p>
      </div>
    </div>
  );
};